module.exports = __webpack_public_path__ + "img/fill.06fb5591.svg";